import { Environment } from './types/environment.type';

export const environment: Environment = {
  name: 'dev',
  logLevelDebug: true,
  baseUrlSasi: 'https://api.aspireasixcockpitdev.aws.platform.porsche-preview.cloud/sasi-admin',
  baseUrlUsers: 'https://api.aspireasixcockpitdev.aws.platform.porsche-preview.cloud/users',
  baseUrlExcessReturn:
    'https://api.aspireasixcockpitdev.aws.platform.porsche-preview.cloud/excess-return',
  baseUrlStocklocator:
    'https://api.aspireasixcockpitdev.aws.platform.porsche-preview.cloud/stocklocator',
  baseUrlCentralRouting:
    'https://api.aspireasixcockpitdev.aws.platform.porsche-preview.cloud/central-routing',
  idpIssuer: 'https://ppnlite.porsche.com',
  idpPathJwks: '',
  idpClientId: 'c11fbb38-ddde-4976-a9e9-7d8491e032c7',
  idpAudience: 'urn:ppn:aspire-cockpit-dev',
  idpScope: 'openid profile email',
};
